const base = (process.env.BASE_URL || '/').replace(/\/?$/, '/');
export const DEF_EMPTY_LOGO_IMG_PATH = base + 'assets/images/empty-logo.svg';
export const DEF_EMPTY_PRD_IMG_PATH = base + 'assets/images/empty.png';

/** API에서 받은 상대 경로를 /tech 기준 절대 경로로 변환 */
export function resolveAssetPath(path) {
  if (!path || typeof path !== 'string') return path;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return base + path.replace(/^\.\//, '');
}
